import { useState } from "react";

export default function FAQItem({ faq }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={`faq-item ${open ? "open" : ""}`}>
      <button
        className="faq-question"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
      >
        {faq.question}
        <span className="arrow" />
      </button>
      {open && <p className="faq-answer">{faq.answer}</p>}
    </div>
  );
}